import { Flex } from "@mantine/core";
import { DataTableSortStatus } from "mantine-datatable";
import { useCallback, useState } from "react";

import { useClikAddresses } from "../../../../api/hooks/clikResult/useClikAddresses.ts";
import SectionTitle from "../../../../components/Section/SectionTitle/SectionTitle.tsx";
import Table from "../../../../components/Table/Table.tsx";
import { SortDirection } from "../../../../components/Table/types.ts";
import { ClikAddressOrderBy, OrderBy } from "../../../../graphql/generated.ts";
import { getApiOrderBy } from "../../../../utils/api.ts";
import { useCRAddressesTableData } from "./hooks/useCRAddressesTableData.tsx";

interface ClikResultAddressesProps {
  clikResultId: number;
}

const ClikResultAddresses = ({ clikResultId }: ClikResultAddressesProps) => {
  const [orderBy, setOrderBy] = useState<ClikAddressOrderBy>({
    id: OrderBy.Desc,
  });

  const [{ data, fetching }] = useClikAddresses({
    clikResultId,
    orderBy,
  });

  const clikAddresses = data?.clikAddresses;

  const [columns, rows] = useCRAddressesTableData({
    data: clikAddresses,
  });

  const handleSortChange = useCallback(
    (sort: DataTableSortStatus) => {
      setOrderBy(getApiOrderBy(sort));
    },
    [setOrderBy]
  );

  return (
    <Flex direction="column" gap={16}>
      <SectionTitle variant="golden">Addresses</SectionTitle>
      <Table
        loading={fetching}
        columns={columns}
        rows={rows}
        minWidth="100%"
        defaultSort={{
          columnAccessor: "id",
          direction: SortDirection.asc,
        }}
        onSortChange={handleSortChange}
      />
    </Flex>
  );
};

export default ClikResultAddresses;
